import { defineComponent as _defineComponent } from 'vue'

import { __ } from '@@/bits/intl'
import type { Post, WallCustomPostProperty } from '@@/types'
import type { Ref, VNodeData } from 'vue'
import { computed, onMounted, ref } from 'vue'

interface PostPropertyDisplayAttributes {
  id: string
  name: string
  value: string
}

export type CustomPropertyTextRefs = Record<'customPropertyLabelRefs' | 'customPropertyValueRefs', Ref<HTMLElement[]>>
const __default__ = {}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SurfacePostProperties',
  props: {
    darkMode: { type: Boolean },
    locationName: { default: undefined },
    wallCustomPostProperties: null,
    customPropertyValues: null,
    propertyLabelClass: { default: 'text-body-extra-small' },
    propertyValueClass: { default: 'text-body-small' }
  },
  emits: ["dblclick", "update:text-element-refs"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'dblclick', event: MouseEvent): void
  (name: 'update:text-element-refs', event: CustomPropertyTextRefs)
}), expose: any, slots: any, attrs: any }) {

const props = __props as { darkMode: boolean, locationName: string, wallCustomPostProperties: WallCustomPostProperty[], customPropertyValues: Post['custom_properties'], propertyLabelClass: string, propertyValueClass: string }





const customPostProperties = computed<PostPropertyDisplayAttributes[]>(() => {
  return props.wallCustomPostProperties
    .filter((property) => property.id != null)
    .map(
      ({ id, name }) =>
        ({
          id,
          name,
          value: props.customPropertyValues != null ? props.customPropertyValues[id!] : '', // assert TS type for id; we already checked id != null
        } as PostPropertyDisplayAttributes),
    )
    .filter(({ value }) => value != null && value !== '')
})

const postProperties = computed<PostPropertyDisplayAttributes[]>(() => {
  const properties: PostPropertyDisplayAttributes[] = []
  if (props.locationName) {
    properties.push({
      id: 'post-property-location',
      name: __('Location'),
      value: props.locationName,
    })
  }
  properties.push(...customPostProperties.value)
  return properties
})

const customPropertyLabelRefs: Ref<HTMLElement[]> = ref([])
const customPropertyValueRefs: Ref<HTMLElement[]> = ref([])

const addLabelRef: VNodeData['ref'] = (e): void => {
  customPropertyLabelRefs.value.push(e as HTMLElement)
}

const addValueRef: VNodeData['ref'] = (e): void => {
  customPropertyValueRefs.value.push(e as HTMLElement)
}

onMounted(() => {
  emit('update:text-element-refs', {
    customPropertyLabelRefs,
    customPropertyValueRefs,
  })
})

return { __sfc: true,props, emit, customPostProperties, postProperties, customPropertyLabelRefs, customPropertyValueRefs, addLabelRef, addValueRef }
}

})